export default "__VITE_ASSET__J6nNKdJ9__"